<template>
  <div class="living-options-dwellings">
    <div class="row">
      <div class="col-12">
        <div class="dwellings">
          <h3>Dwellings</h3>
          <button class="btn btn-sm btn-primary mb-4" @click="addDwelling">
            Add Dwelling
          </button>
          <div class="row mb-2">
            <div class="col-4">
              <div class="status-option">
                <input
                  type="checkbox"
                  id="active"
                  value="Active"
                  v-model="filterActiveStates"
                />
                <label class="status-option__label" for="active">Active</label>
              </div>

              <div class="status-option">
                <input
                  type="checkbox"
                  id="inactive"
                  value="Inactive"
                  v-model="filterActiveStates"
                />
                <label class="status-option__label" for="inactive"
                  >Inactive</label
                >
              </div>
            </div>
          </div>
          <div class="row mb-4">
            <div class="col-4">
              <label for="filterRelease">Filter By Release</label>
              <select
                class="form-control"
                name="filterRelease"
                v-model="filterReleaseId"
              >
                <option value="">All Releases</option>
                <option
                  v-for="subsection in subsectionsOrdered"
                  :value="subsection.id"
                >
                  {{ subsection.label }}
                </option>
              </select>
            </div>
          </div>
          <div class="mb-2">
            <input
              class="form-control"
              type="text"
              v-model="dwellingFilterText"
              placeholder="Filter dwellings"
            />
          </div>
          <v-table
            :columns="[
              {
                label: 'Label',
                field: 'label',
              },
              {
                label: 'Builder',
                field: 'builderLabel.en',
                options: {
                  sortable: true,
                  return: function (fieldValue) {
                    return fieldValue;
                  },
                },
              },
              {
                label: 'Attached to Lots',
                field: 'associatedLots',
                options: {
                  sortable: true,
                  return: function (row) {
                    if (!row.length) {
                      return '-';
                    }

                    return row
                      .map((property) => {
                        return renderPropertyCell(property);
                      })
                      .join('');
                  },
                },
              },
            ]"
            :rows="filteredDwellings"
            :show-active-toggle="
              activeUser.access.indexOf('live-toggle') !== -1
            "
            save-action="SAVE_DWELLING"
            @edit="editDwelling($event._id)"
            @clone="cloneDwelling($event)"
            @delete="deleteDwelling($event._id)"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import VTable from "@/components/VTable";
import { property } from "lodash";
import { renderPropertyCell } from "@/common/helpers";

export default {
  components: {
    VTable,
  },

  data() {
    return {
      dwellingFilterText: "",
      showActiveOnly: false,
      filterActiveStates: [],
      filterReleaseId: "",
    };
  },

  computed: {
    ...mapGetters(["dwellings", "subsections"]),

    subsectionsOrdered() {
      return this.subsections.sort((a, b) => {
        const labelA = a.label.toUpperCase();
        const labelB = b.label.toUpperCase();

        if (labelA < labelB) {
          return -1;
        } else {
          return 1;
        }
      });
    },

    activeUser() {
      return this.$store.getters.user;
    },

    filteredDwellings() {
      let dwellings = this.dwellings;
      if (this.showActiveOnly) {
        dwellings = dwellings.filter((dwelling) => dwelling.active);
      }

      let filtered = dwellings.filter((dwelling) =>
        dwelling.label
          .toLowerCase()
          .includes(this.dwellingFilterText.toLowerCase())
      );

      if (this.filterReleaseId) {
        filtered = filtered.filter((dwelling) =>
          dwelling.associatedReleases.includes(this.filterReleaseId)
        );
      }

      if (this.filterActiveStates.length) {
        filtered = filtered.filter(
          (dwelling) =>
            (this.filterActiveStates.includes("Active") && dwelling.active) ||
            (this.filterActiveStates.includes("Inactive") && !dwelling.active)
        );
      }

      return filtered;
    },
  },

  watch: {
    filterReleaseId() {
      this.$router.push({ query: { filterReleaseId: this.filterReleaseId } });
    },
  },

  created() {
    this.$store.dispatch("FETCH_DWELLINGS");
    this.$store.dispatch("FETCH_SUBSECTIONS");
  },

  mounted() {
    if (this.$route.query.filterReleaseId) {
      this.filterReleaseId = this.$route.query.filterReleaseId;
    }
  },

  methods: {
    renderPropertyCell,

    async addDwelling() {
      const newDwelling = await this.$store.dispatch("ADD_NEW_DWELLING");
      this.$store.dispatch("SAVE_DWELLING", newDwelling);
      this.editDwelling(newDwelling._id);
    },

    async cloneDwelling(dwelling) {
      const clonedDwelling = await this.$store.dispatch(
        "CLONE_DWELLING",
        dwelling
      );
      this.$store.dispatch("SAVE_DWELLING", clonedDwelling);
    },

    deleteDwelling(id) {
      if (confirm("Are you sure?")) {
        this.$store.dispatch("DELETE_DWELLING", id);
      }
    },

    editDwelling(id) {
      this.$router.push(`dwellings/${id}`);
    },
  },
};
</script>
